module.exports = __webpack_public_path__ + "static/img/shengxian_LOGO.7d4350b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shengxian_LOGO.png
// module id = EeRN
// module chunks = 52